import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DatepickerDropdownComponent, DateTimeService, EditorComponentBase, IEditorItemConfig } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-date-editor',
    templateUrl: './date-editor.component.html',
    styleUrls: ['./date-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatepickerDropdownComponent, ValidationErrorMessageComponent]
})
export class DateEditorComponent extends EditorComponentBase<Date | null> {
    selectedDate?: Date;
    minDate?: Date;
    selectedTimeChanged?: string;

    timeEnabled: boolean;

    constructor(readonly dateTimeService: DateTimeService) {
        super();
        this.timeEnabled = false;
    }

    override initialize(config: IEditorItemConfig): void {
        super.initialize(config);

        this.timeEnabled = this.additionalInfo?.timeEnabled;
        this.minDate = this.additionalInfo?.minDate;
        this.selectedDate = this.toValidDate(this.bindingProperty);
    }

    onSelectedDateChange() {
        const previousDate = this.toValidDate(this.bindingProperty);
        const currentDate = this.selectedDate;
        let hasChanged: boolean;

        if (this.timeEnabled) {
            hasChanged = previousDate?.getTime() !== currentDate?.getTime();
        } else {
            hasChanged = previousDate?.toDateString() !== currentDate?.toDateString();
        }

        if (this.selectedDate) {
            this.bindingProperty = this.selectedDate;
            this.validate();
        } else {
            this.bindingProperty = null;
        }

        if (hasChanged) {
            this.valueChange.emit();
        }
    }

    private toValidDate(value: Date | string | null | undefined): Date | undefined {
        if (!value) {
            return undefined;
        }

        if (value instanceof Date) {
            return Number.isNaN(value.getTime()) ? undefined : value;
        }

        const parsedDate = this.dateTimeService.formatDateTimeToDate(this.dateTimeService.getDateTimeFromString(value));
        return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
    }
}
